import Vue from "vue";
import Router from "vue-router";
import routeList from "./modules";
import { wxsharepublic } from "../utils/wxShare.js";
import { baseUrl } from "@/utils/common";
// 引入接口
// import requestGlobal from "@/api";
// 引入微信
// import wx from "weixin-js-sdk";

Vue.use(Router);

// 解决重复点击相同路由报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      redirect: "/manager/home",
      component: () => import("@/pages/index"),
      children: [{
        path: "/manager/home",
        name: "Home",
        meta: {
          title: "首页",
          isKeepLive: false,  // 是否缓存
          isBack: false  // 返回效果
        },
        component: () => import("@/pages/manager/home")
      }
      ]
    },
    {
      path: "/customer",
      name: "CustomerIndex",
      redirect: "/customer/createOrder",
      component: () => import("@/pages/customerIndex"),
      children: [{
        path: "/customer/createOrder",
        name: "CreateOrder",
        meta: {
          title: "提单支付页",
          isKeepLive: false,  // 是否缓存
          isBack: false  // 返回效果
        },
        component: () => import("@/pages/customer/createOrder")
      },
      ...routeList
      ]
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录",
        isKeepLive: false,  // 是否缓存
        isBack: false  // 返回效果
      },
      component: () => import("@/pages/login")
    },
    {
      path: "/register",
      name: "Register",
      meta: {
        title: "注册",
        isKeepLive: false,  // 是否缓存
        isBack: false  // 返回效果
      },
      component: () => import("@/pages/register")
    }
  ]
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 客户经理需要登录才可以进入系统 终端客户是不需要登陆的
  if (localStorage.getItem("userType") && localStorage.getItem("userType") == "manager" && localStorage.getItem("userInfo") && localStorage.getItem("userInfo") != "") {
    // 已登录去首页
    if (to.path == "/register" || to.path == "/login") {
      next({ path: "/" });
    } else if (to.path == "/customer/createOrder") {
      next({ path: "/" });
    } else {
      next();
    }
  } else if (localStorage.getItem("userType") && localStorage.getItem("userType") == "customer") {
    // 已登录去客户首页
    if (to.path == "/register" || to.path == "/login") {
      next({ path: "/customer" });
    } else if (to.path == "/") {
      next({ path: "/customer" });
    } else if (to.path == "/manager/home") {
      next({ path: "/customer" });
    } else {
      next();
    }
  } else {
    if (to.path == "/register" || to.path == "/login") {
      // 重新触发的时候会进入到这里,因为to.path已经变为/register了，然后直接跳转到登录页
      next();
    } else if (to.path == "/" || to.path == "/manager/home" || to.path == "/manager/examplePage" || to.path == "/manager/homeAdLeft" || to.path == "/manager/homeAdRight" || to.path == "/manager/fourhundredPage" || to.path == "/manager/fourhundredDetail" || to.path == "/manager/hmrzOrderDetail") {
      next();
    } else {
      next({ path: "/login" });
    }
  }
  next(); // 一定要调用next(),否则会造成页面卡死在登录页 ???
});

router.afterEach((to, from) => {
  if (to.path != "/manager/examplePage") {
    if (to.path == "/manager/fourhundredPage") {
      setTimeout(() => {
        // 设置分享信息
        let shareLink = location.href;
        wxsharepublic("400电话选号", "去选号", baseUrl + "/projectimg/newlogo.png", shareLink);
      }, 1000);
    } else {
      setTimeout(() => {
        if (localStorage.getItem("userType") && localStorage.getItem("userType") == "customer") {
          // 设置分享信息
          let shareLink = location.href.split("#")[0];
          wxsharepublic("企业业务营销通", "轻松赚现金，多邀多得", baseUrl + "/projectimg/newlogo.png", shareLink);
        } else {
          let shareLink = baseUrl + "/?sysuserid=" + (localStorage.getItem("sysuserid") || "") + "&registertype=2" + "&customeruid=" + (localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).customeruid : "");
          wxsharepublic("企业业务营销通", "轻松赚现金，多邀多得", baseUrl + "/projectimg/newlogo.png", shareLink);
        }
      }, 1000);
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js